<template>
	<div>
		<template v-if="propsRowLocal && propsRowLocal.entity">
			<div class="is-flex is-justify-content-center is-align-items-center">
				<div style="cursor: pointer" @click="setRow(undefined)">
					<b-icon icon="delete" color="black" />
				</div>
				<div v-if="propsRowLocal.entity.attributes.group_name">
					{{ propsRowLocal.entity.attributes.group_name }}
				</div>
				<div v-else>
					{{ propsRowLocal.entity.attributes.first_name }} {{ propsRowLocal.entity.attributes.last_name }}
				</div>
			</div>
		</template>
		<b-field v-else type="is-danger" message="Bitte wähle einen Klienten oder eine Gruppe">
			<b-autocomplete placeholder="Entität" :data="propsRowLocal.processedEntities" icon="magnify" field="name"
				:clearable="true" :open-on-focus="true" @input="val => setProcessedEntities(val)"
				@select="(option) => option ? setEntity(option) : setEntity(undefined)">
				<template #default="props">
					<div v-if="props.option.attributes.group_name">
						{{ props.option.attributes.group_name }}
					</div>
					<div v-else>
						{{ props.option.attributes.first_name }} {{ props.option.attributes.last_name }}
					</div>
				</template>
			</b-autocomplete>
		</b-field>
	</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
	name: "FirstColumn",
	props: ["propsRow", "rowId"],
	data() {
		return {
			propsRowLocal: cloneDeep(this.propsRow) // Kopie erstellen
		}
	},
	methods: {
		setRow(value) {
			if (this.propsRowLocal) {
				this.propsRowLocal.entity = value;
				this.$emit('update:propsRow', { "rowData": this.propsRowLocal, "rowId": this.rowId });
			}
		},
		setProcessedEntities(val) {
			if (this.propsRowLocal) {
				this.propsRowLocal.processedEntities = this.propsRowLocal.entities.filter(e => {
					if (!val) return true
					if (e.attributes.group_name) return e.attributes.group_name.toLowerCase().includes(val.toLowerCase())
					return `${e.attributes.first_name} ${e.attributes.last_name}`.toLowerCase().includes(val.toLowerCase())
				})
				this.$emit('update:propsRow', { "rowData": this.propsRowLocal, "rowId": this.rowId });
			}
		},
		setEntity(value) {
			if (this.propsRowLocal) {
				this.propsRowLocal.entity = value;
				this.$emit('update:propsRow', { "rowData": this.propsRowLocal, "rowId": this.rowId });
			}
		}

	}
}
</script>

<style scoped></style>